import styled from 'styled-components';
import { media, themed } from '@/shared/ui/core';

export const InfoNoticeContent = styled.div.attrs({
  className: 'InfoNotice',
})`
  align-items: center;
  background-color: ${themed('primary.lightGreen')};
  border-radius: 0.25rem;
  color: ${themed('primary.accent')};
  display: flex;
  font-size: 0.75rem;
  line-height: 1.35;
  min-height: 3rem;
  padding: 0.5rem;
  position: relative;
  width: 100%;

  @media ${media.desktopMin} {
    font-size: 0.8125rem;
  }
`;

export const IconContainer = styled.div.attrs({
  className: 'IconContainer',
})`
  width: 2rem;
  border-radius: 50%;
  margin: auto 0.8rem auto 0.5rem;

  svg {
    display: block;
    margin: auto;
    max-width: 20px;

    path {
      fill: ${themed('primary.accent')};
    }
  }
`;
